import React, { FC } from 'react';
import { Box, Button, Container } from '@mui/material';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/OffRoadToursPromoSection/OffRoadToursPromoSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  GridsGallery,
  ImgBox,
  Typography700,
} from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import Typography500 from 'views/common/components/UI/Typography500';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { OFF_ROAD_LANDING_REF } from 'views/rebranded-module/OffRoadToursLandingViewV2/utils/constants';

const OffRoadToursPromoSection:FC<any> = (props) => {
  const { promoTour } = props;
  const content = useContent('OffRoadLandingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  const tourLink = PATHS.tour.index(promoTour.tour_type.slug, promoTour.slug, {
    ref: OFF_ROAD_LANDING_REF,
  });
  return (
    <StyledBox>
      <Box className="ORTBGPattern">
        <ImgBox
          image={{
            src: getSizedImage(content.patternBackground),
            alt: content.patternBackground.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
      </Box>
      <Container maxWidth="xl">
        <Typography700 variant="overline2" component="p" mb={2} color="primary">
          {promoTour.tour_type.name}
        </Typography700>
        <Typography700 component="p" variant="h6" mb={5}>
          {promoTour.name}
        </Typography700>
        <GridsGallery mediaItems={promoTour.gallery} />
        <Typography700
          variant="overline2"
          component="p"
          mt={4}
          mb={1.25}
          color="primary">
          {promoTour.name}
        </Typography700>
        <Typography700 component="p" variant="h6" mb={2.75}>
          {promoTour.subTitle}
        </Typography700>
        <Typography500
          variant="body2"
          component="p"
          mb={3}
          color="text.secondary">
          {promoTour.tagline}
          {' • '}
          {promoTour.tour_type.name}
          {' • '}
          {interpolateString(content.distanceDisplay, {
            miles: promoTour.distance.miles,
            km: promoTour.distance.km,
          })}
          {' • '}
          {interpolateString(content.tempDisplay, {
            f: `${promoTour.temperature.fahrenheit.low} - ${promoTour.temperature.fahrenheit.high}`,
            c: `${promoTour.temperature.celsius.low} - ${promoTour.temperature.celsius.high}`,
          })}
        </Typography500>
        <Typography500
          variant="body2"
          component="p"
          mb={1}
          className="OTPSDesc"
          color="text.secondary">
          {content.promoDescription}
        </Typography500>
        <Button
          component={NavigatorLink}
          href={tourLink as any}
          data-testid={`offroad-promo-tour-${encodeURIComponent(promoTour.slug)}`}
          variant="contained"
          color="primary">
          {content.learnMoreBtnLabel}
        </Button>
      </Container>
    </StyledBox>
  );
};

export { OffRoadToursPromoSection };
